export default class OnlineDurationRecordController {
  static list (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/onlineDurationRecord/list', 'post', params, axiosOption, httpOption);
  }

  static view (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/onlineDurationRecord/view', 'get', params, axiosOption, httpOption);
  }

  static export (sender, params, fileName) {
    return sender.download('/admin/app/onlineDurationRecord/export', params, fileName);
  }

  static add (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/onlineDurationRecord/add', 'post', params, axiosOption, httpOption);
  }

  static update (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/onlineDurationRecord/update', 'post', params, axiosOption, httpOption);
  }

  static delete (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/onlineDurationRecord/delete', 'post', params, axiosOption, httpOption);
  }

  static yearList (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/onlineDurationRecord/yearDurationList', 'post', params, axiosOption, httpOption);
  }
  static exportYear (sender, params, fileName) {
    return sender.download('/admin/app/onlineDurationRecord/exportYear', params, fileName);
  }
}
